const CHAT_ERROR_PREFIX = "⚠️ Error: ";
export const SPEND_LIMIT_CHAT_ERROR_TITLE = "Spend limit reached";
const SPEND_LIMIT_CHAT_ERROR_PREFIX = `${SPEND_LIMIT_CHAT_ERROR_TITLE}. `;
const MODEL_CHAT_ERROR_PREFIX = "Model error. ";

export function formatChatError(errorMessage: string): string {
  return `${CHAT_ERROR_PREFIX}${errorMessage}`;
}

export function formatSpendLimitError(message: string): string {
  return `${SPEND_LIMIT_CHAT_ERROR_PREFIX}${message}`;
}

export function formatModelError(message: string): string {
  return `${MODEL_CHAT_ERROR_PREFIX}${message}`;
}

export function parseChatError(
  text: string
): { title: string; message: string; isModelError: boolean } | null {
  if (!text.startsWith(CHAT_ERROR_PREFIX)) return null;
  const message = text.slice(CHAT_ERROR_PREFIX.length);
  if (message.startsWith(SPEND_LIMIT_CHAT_ERROR_PREFIX)) {
    return {
      title: SPEND_LIMIT_CHAT_ERROR_TITLE,
      message: message.slice(SPEND_LIMIT_CHAT_ERROR_PREFIX.length),
      isModelError: false,
    };
  }
  if (message.startsWith(MODEL_CHAT_ERROR_PREFIX)) {
    return {
      title: "Something went wrong",
      message: message.slice(MODEL_CHAT_ERROR_PREFIX.length),
      isModelError: true,
    };
  }
  return { title: "Something went wrong", message, isModelError: false };
}
